<div class="main-content profile-editor-page project-admin-editor-page risk-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ pageTitle }}</h1>
        <p>{{ pageSubtitle }}</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="navigateBack()">
          Regresar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary"
          [disabled]="formRiesgo.invalid"
          (click)="guardaActualizaRiesgo()">
          Guardar riesgo
        </button>
      </div>
    </section>

    <div class="row risk-editor-page__layout">
      <div class="col-12 col-xl-8 d-flex">
        <section class="profile-editor-page__card project-admin-editor-page__card risk-editor-page__card risk-editor-page__card--form">
          <div class="profile-editor-page__card-header">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">warning_amber</i>
              <span>Captura de riesgo</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <form [formGroup]="formRiesgo" autocomplete="off">
              <div class="row project-admin-editor-page__form-grid">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Fase de detección</mat-label>
                    <mat-select formControlName="faseDeteccionCtrl" [(ngModel)]="riesgo.id_fase_deteccion">
                      <mat-option *ngFor="let item of faseDeteccion" [value]="item.id_fase">
                        {{ item.nombre_faseDeteccion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('faseDeteccionCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Tipo de riesgo</mat-label>
                    <mat-select formControlName="tipoRiesgoCtrl" [(ngModel)]="riesgo.id_tipo_riesgo">
                      <mat-option *ngFor="let item of tipoRiesgo" [value]="getTipoRiesgoValue(item)">
                        {{ getTipoRiesgoLabel(item) }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('tipoRiesgoCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Probabilidad</mat-label>
                    <mat-select formControlName="probabilidadCtrl" [(ngModel)]="riesgo.id_probabilidad">
                      <mat-option *ngFor="let item of probabilidad" [value]="item.id_probabilidad">
                        {{ item.nombre }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('probabilidadCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Impacto</mat-label>
                    <mat-select
                      formControlName="impactoCtrl"
                      [(ngModel)]="riesgo.id_impacto"
                      (selectionChange)="calcularProbabilidadImpacto()">
                      <mat-option *ngFor="let item of impacto" [value]="item.id_impacto">
                        {{ item.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('impactoCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Fecha de identificación</mat-label>
                    <input
                      matInput
                      [matDatepicker]="fechaIdentificacionPicker"
                      formControlName="fechaCtrl"
                      [(ngModel)]="riesgo.fecha_identificacion"
                      aria-label="Fecha de identificación" />
                    <mat-datepicker-toggle matIconSuffix [for]="fechaIdentificacionPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fechaIdentificacionPicker></mat-datepicker>
                    <mat-error *ngIf="isInvalid('fechaCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Periodicidad</mat-label>
                    <mat-select formControlName="periodicidadCtrl" [(ngModel)]="riesgo.id_periodicidad">
                      <mat-option *ngFor="let item of periodicidad" [value]="item.id_periodicidad">
                        {{ item.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('periodicidadCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Descripción</mat-label>
                    <textarea matInput rows="4" formControlName="descripcionCtrl" [(ngModel)]="riesgo.descripcion"
                      aria-label="Descripción"></textarea>
                    <mat-error *ngIf="isInvalid('descripcionCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Causa raíz</mat-label>
                    <textarea matInput rows="4" formControlName="causaRaizCtrl" [(ngModel)]="riesgo.causa_raiz"
                      aria-label="Causa raíz"></textarea>
                    <mat-error *ngIf="isInvalid('causaRaizCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Estrategia a seguir</mat-label>
                    <mat-select formControlName="estrategiaCtrl" [(ngModel)]="riesgo.id_estrategia">
                      <mat-option *ngFor="let item of estrategia" [value]="item.id_estrategia">
                        {{ item.estrategia }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('estrategiaCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Responsable / recurso</mat-label>
                    <input matInput formControlName="responsableRecursoCtrl" [(ngModel)]="riesgo.responsable_recurso"
                      aria-label="Responsable / recurso" />
                    <mat-error *ngIf="isInvalid('responsableRecursoCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Acciones a seguir</mat-label>
                    <textarea matInput rows="4" formControlName="accionesSeguirCtrl" [(ngModel)]="riesgo.acciones_seguir"
                      aria-label="Acciones a seguir"></textarea>
                    <mat-error *ngIf="isInvalid('accionesSeguirCtrl')">Campo requerido.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-4 d-flex">
        <div class="risk-editor-page__sidebar">
          <section class="profile-editor-page__card risk-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">inventory_2</i>
                <span>Contexto</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="risk-editor-page__summary-list">
                <div class="risk-editor-page__summary-item">
                  <span>Proyecto</span>
                  <strong>{{ projectName || ("Proyecto #" + riesgo.id_proyecto) }}</strong>
                </div>
                <div class="risk-editor-page__summary-item">
                  <span>Cliente</span>
                  <strong>{{ projectClient || "Sin cliente asignado" }}</strong>
                </div>
                <div class="risk-editor-page__summary-item">
                  <span>ID proyecto</span>
                  <strong>{{ riesgo.id_proyecto }}</strong>
                </div>
              </div>
            </div>
          </section>

          <section class="profile-editor-page__card risk-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">monitor_heart</i>
                <span>Severidad calculada</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="risk-editor-page__severity-card">
                <span class="risk-editor-page__severity-dot" [style.background]="colorSeveridad"></span>
                <div class="risk-editor-page__severity-copy">
                  <strong>{{ nombreSeveridad }}</strong>
                  <span>
                    {{
                      riesgo.calculo_severidad != null
                        ? ("Valor calculado: " + riesgo.calculo_severidad)
                        : "Seleccione probabilidad e impacto para calcular la severidad."
                    }}
                  </span>
                </div>
              </div>

              <div class="risk-editor-page__support">
                <i class="material-icons">tips_and_updates</i>
                <span>
                  Capture el riesgo como pantalla completa para mantener consistencia con los formularios homologados del admin.
                </span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
